import angular from 'angular';

let ApiaccesslogDetailController = function ($filter, $mdDialog, $scope, $state, $timeout, City, News, Apiaccesslog, State, Toast) {
  let $ctrl = this;

  $ctrl.apiaccesslog = $state.params.id;

  angular.extend($ctrl, {
    onChangeDate,
    onChangeState,
    querySearch,
    selectedNewsItemChange
  });

  activate();

  function activate() {
    $ctrl.uiState = 'LOADING';
    if (!$ctrl.apiaccesslog) $state.go('apiaccesslog.list');
    else  {
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function onChangeDate(form) {
    $timeout(() => {
      form.sendAtTime.$validate();
    }, 100);
  }

  function onChangeState(stateId) {
    $ctrl.apiaccesslog.city_id = undefined;
    $ctrl.loadingCities = true;

    City
      .index({
        state_id: stateId,
        limit: 1000000
      })
      .then(cities => {
        $ctrl.cities = cities;
        $ctrl.loadingCities = false;
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.loadingCities = false;
      });
  }

  function querySearch(searchText) {
    searchText = searchText.toLowerCase();
    let newsTypeToExclude = $ctrl.apiaccesslog.type === 'MEDIC' ? 'SBRUBBLES' : 'MEDIC';

    let results = _.filter($ctrl.newsItems, newsItem => {
      return newsItem.title.toLowerCase().indexOf(searchText) > -1 && newsItem.user_profile_type != newsTypeToExclude;
    });

    return results;
  }

  function selectedNewsItemChange(newsItem) {
    $ctrl.apiaccesslog.type_id = newsItem ? newsItem.id : null;
  }
}

ApiaccesslogDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'City', 'News', 'Apiaccesslog', 'State', 'Toast'];

export default ApiaccesslogDetailController;


// WEBPACK FOOTER //
// ./client/app/components/apiaccesslog/apiaccesslog-detail.controller.js